var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubStorageIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5625 20.2496H6.375C4.66687 20.2496 3.07687 19.6604 1.89797 18.5897C0.674063 17.4783 0 15.9371 0 14.2496C0 12.5349 0.627656 11.0565 1.815 9.97364C2.66391 9.1988 3.79406 8.64942 5.05781 8.38599C5.1743 8.36188 5.28338 8.31042 5.37605 8.23584C5.46872 8.16126 5.54232 8.06571 5.59078 7.95708C6.04073 6.94421 6.71469 6.04666 7.56188 5.33208C8.80125 4.29755 10.3359 3.74958 12 3.74958C13.8718 3.74143 15.6733 4.46274 17.0222 5.76052C18.1814 6.87661 18.9675 8.35177 19.3275 10.073C19.3564 10.2142 19.4254 10.344 19.5261 10.447C19.6269 10.55 19.7551 10.6218 19.8956 10.6538C22.0312 11.1286 24 12.676 24 15.3746C24 16.9397 23.4263 18.2236 22.3402 19.0885C21.3858 19.8479 20.0798 20.2496 18.5625 20.2496Z",
    fill: "#373737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubStorageIc);
export default __webpack_public_path__ + "static/media/sub_storage_ic.9b2510ec2b62907aa517351a1375276f.svg";
export { ForwardRef as ReactComponent };